import { render } from "./StepThreeGroup.vue?vue&type=template&id=715a2354"
import script from "./StepThreeGroup.vue?vue&type=script&lang=js"
export * from "./StepThreeGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__